import { m as n } from "./index863.mjs";
var a = n, m = function(t) {
  var r = +t;
  return r !== r || r === 0 ? 0 : a(r);
};
export {
  m as t
};
